import { AlignLeft } from 'lucide-react';
import React from 'react';
import { NavLink } from 'react-router-dom';

const AllSubjects = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-8xl mx-auto">
        {/* Hero Section with Image and Text */}
        <div className="hero rounded-2xl shadow-2xl overflow-hidden bg-white">
          <div className="hero-content flex-col lg:flex-row-reverse gap-8 p-0">
            {/* Free Online Image from Unsplash (Online Tutoring) */}
            <div className="w-full lg:w-1/2">
              <img
                src="https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2032&q=80"
                alt="Student studying online with laptop"
                className="w-full h-full object-cover max-h-[500px] rounded-l-2xl"
              />
            </div>
            
            <div className="text-center lg:text-left p-8 lg:p-12 lg:w-1/2 space-y-6">
              <h1 className="text-2xl font-bold text-gray-800">
                All Subjects Tuition
              </h1>
              <h2 className="text-xl font-semibold text-gray-700">
                For Grades <span className="text-primary">1 - 7</span>
              </h2>
              <p className="text-base text-gray-600 leading-relaxed">
                🎯 Expert online tutoring for every subject! 
                From Mathematics to Science, English to Computer, 
                we've got your child covered.
              </p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start mt-6">
                <div className="badge badge-primary badge-lg">Mathematics</div>
                <div className="badge badge-secondary badge-lg">Science</div>
                <div className="badge badge-accent badge-lg">English</div>
                <div className="badge badge-info badge-lg">Hindi</div>
                <div className="badge badge-error badge-lg">Arabic</div>
                <div className="badge badge-success badge-lg">Social Science</div>
                <div className="badge badge-warning badge-lg">IT</div>
                <div className="badge badge-neutral badge-lg">Spoken English</div>
              </div>
              <div className="mt-8">
              <NavLink to="/about" className="btn btn-primary btn-wide gap-2 shadow-lg hover:shadow-xl transition-all">
                  Get Free Demo Class
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-gray-800 mb-10">
            Why Choose Our Online Tuition?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="card-body items-center text-center">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-primary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                  </svg>
                </div>
                <h2 className="card-title">1-on-1 Attention</h2>
                <p className="text-gray-500">AI Powered Personalized learning plans for each student</p>
              </div>
            </div>

            <div className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="card-body items-center text-center">
                <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-secondary">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h2 className="card-title">Flexible Timing</h2>
                <p className="text-gray-500">Schedule classes at your convenience</p>
              </div>
            </div>

            <div className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="card-body items-center text-center">
                <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-accent">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                  </svg>
                </div>
                <h2 className="card-title">Expert Tutors</h2>
                <p className="text-gray-500">Qualified & experienced subject specialists</p>
              </div>
            </div>

            <div className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
              <div className="card-body items-center text-center">
                <div className="w-16 h-16 rounded-full bg-info/10 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-info">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15" />
                  </svg>
                </div>
                <h2 className="card-title">Free Resources</h2>
                <p className="text-gray-500">Worksheets, quizzes & study materials</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action Banner */}
        <div className="mt-16 bg-primary text-primary-content rounded-2xl p-8 justify-center shadow-xl">
          {/* <div className="flex flex-col md:flex-row justify-between items-center gap-4"> */}
            {/* <div className="space-y-2">
              <h3 className="text-xl font-bold">Limited Time Offer!</h3>
              <p className="text-base opacity-90">Sign up today and get 2 weeks of free trial classes</p>
            </div> */}

<NavLink to="/about" className="btn btn-primary btn-lg mt-5 border-2 border-white text-white hover:bg-white hover:text-primary transition-all">
             
            
                 Claim Your Free Trial
          
</NavLink>

          </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AllSubjects;